/* eslint-disable */
import React, { useState } from 'react';
import SideBarContainer from 'Containers/SideBarContainer';
import BasicTable from '../../Components/BasicTable';
import useEmployee from './Hooks/useEmployee';
import Search from '../../Components/Search';
import Title from '../../Components/Title';
import DropDown from '../../Components/DropDown';
import style from './style';
import useDropDown from './Hooks/useDropdown';
import useTranslation from '../../Hooks/useTranslation';
import useComponent from './Hooks/useComponent';

const { containerEmployee, searchContainer, findContainer } = style;

export default function Employee() {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const { employees, setEmployees, terminal, department, role, sendToEmployeesAssess } = useEmployee(setIsLoading);

  const { setSearch, setTerminal, setDepartment, setStatus, filteredEmployees } = useDropDown({
    employees,
  });

  const { thereIsComponent } = useComponent({ employees, setEmployees });

  const titles = [t('Employee.Terminal'), t('Employee.Department'), t('Employee.Status')];
  const options = [terminal, department, [t('Generic.Active'), t('Generic.Inactive')]];
  const methods = [setTerminal, setDepartment, setStatus];
  const employeeOptions = ['Ver detalle'];

  return (
    <SideBarContainer>
      <div style={containerEmployee} className="col">
        <Title title={t('Employee.Title')} subtitle={t('Employee.SubTitle')} />
        <div style={searchContainer}>
          <div style={{ width: '40%' }}>
            <Search setData={setSearch} placeholder={t('Employee.Search')} />
          </div>
          <div style={findContainer}>
            {titles.map((title, index) => (
              <DropDown key={title + index} title={title} options={options[index]} setData={methods[index]} />
            ))}
          </div>
        </div>

        <BasicTable
          style={{ width: 'min-content' }}
          information={filteredEmployees}
          headers={[
            t('Employee.EmployeeNumber'),
            t('Employee.Name'),
            t('Employee.Department'),
            t('Employee.JobTitle'),
            t('Employee.Role'),
            t('Employee.Terminal'),
            t('Employee.Status'),
          ]}
          limit={7}
          thereIsComponent={thereIsComponent}
          configButton={employeeOptions}
          configButtonEvents={[sendToEmployeesAssess]}
          isLoading={isLoading}
        />
      </div>
    </SideBarContainer>
  );
}
